const ToConnectionRequestStateEnum = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  REFUSED: 'refused',
};

export default ToConnectionRequestStateEnum;
